import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { DownloadFilePostModel } from "../../models/Download.model";
import axios from "axios";
import * as FS from "file-saver";
import { Email } from "../../models/emailModel.model";
import { ErrorMessageService } from "../error-message/error-message.service";

@Injectable({
    providedIn: "root"
})
export class PrintoutService {

    constructor(private errorMessage: ErrorMessageService, private translate: TranslateService) {

    }

    reportUrl() {
        let url = '';
        if (window["spaSourceUrl"]) {
            url = window["spaSourceUrl"] + environment.urireport;
        } else {
            url = environment.apiUrl + environment.urireport;
        }

        return url;
    }

    downloadFile(downloadParam: DownloadFilePostModel) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: this.reportUrl(),
                data: downloadParam,
                responseType: "arraybuffer",
                headers: {
                    "ocp-apim-subscription-key": environment.urireportkey,
                    "Content-Type": "application/json"
                },
            }).then((response) => {
                const file = new Blob([response.data], { type: "application/pdf" });

                const fileURL = URL.createObjectURL(file);
                const nav = (window.navigator as any);
                if (nav.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(file, 'estimate.pdf');
                }
                else if (window.navigator.userAgent.match('CriOS') || (window.navigator.userAgent.match(/Chrome/i) && window.navigator.userAgent.match(/Mobile/i))) { //Chrome iOS
                    window.open(fileURL, "_blank");
                }
                else {
                    FS.saveAs(file, "estimate.pdf");
                }
            }).catch(error => {
                this.errorMessage.showErrorMessage(error);
                reject(error);
            });
        });
    }

    printAndDownloadPdf(downloadParam: DownloadFilePostModel, operation) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: this.reportUrl(),
                data: downloadParam,
                responseType: "arraybuffer",
                headers: {
                    "ocp-apim-subscription-key": environment.urireportkey,
                    "Content-Type": "application/json"
                },
            }).then((response) => {
                const file = new Blob([response.data], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);


                if (window.navigator.userAgent.match('CriOS') || (window.navigator.userAgent.match(/Chrome/i) && window.navigator.userAgent.match(/Mobile/i))) { //Chrome iOS
                    window.open(fileURL, "_blank");
                }
                else {
                    FS.saveAs(file, "estimate.pdf");
                }
                

            }).catch(error => {
                this.errorMessage.showErrorMessage(error);
                reject(error);
            });
        });
    }
}
